import React from 'react';
import '../styles/floatingreview/FloatingReviewButton.css';


const GOOGLE_FORM_URL = process.env.REACT_APP_GOOGLE_FORM_URL;

const FloatingReviewButton = () => {
    return (
        <div className="floating-review-container">
            <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="floating-review-tooltip"
                aria-label="Give us your feedback"
            >
                <span>Give Us Your Feedback</span>
            </a>
            <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="floating-review-btn"
                aria-label="Leave a Review on Google Form"
            >
                <svg viewBox="0 0 1240 1240" xmlns="http://www.w3.org/2000/svg" className="floating-review-icon">
                    {/* White outer ring */}
                    <circle cx="620" cy="620" r="560" fill="#ffffff" />
                    {/* Teal circle */}
                    <circle cx="620" cy="620" r="510" fill="#1CB4D4" />

                    {/* Document body with folded corner */}
                    <path d="
            M 415 320
            Q 415 290 445 290
            L 745 290
            L 890 435
            L 890 900
            Q 890 930 860 930
            L 445 930
            Q 415 930 415 900
            Z"
                        fill="#ffffff" />

                    {/* Folded corner (lighter shade) */}
                    <path d="
            M 745 290
            L 890 435
            L 785 435
            Q 745 435 745 395
            Z"
                        fill="#7FD4E6" />

                    {/* Speech bubble tail */}
                    <path d="
            M 490 930
            L 490 1015
            L 590 930
            Z"
                        fill="#ffffff" />

                    {/* List dots */}
                    <circle cx="480" cy="585" r="28" fill="#1CB4D4" />
                    <circle cx="480" cy="690" r="28" fill="#1CB4D4" />
                    <circle cx="480" cy="795" r="28" fill="#1CB4D4" />

                    {/* List lines */}
                    <rect x="555" y="568" width="255" height="34" rx="17" fill="#1CB4D4" />
                    <rect x="555" y="673" width="255" height="34" rx="17" fill="#1CB4D4" />
                    <rect x="555" y="778" width="255" height="34" rx="17" fill="#1CB4D4" />
                </svg>
            </a>
        </div>
    );
};

export default FloatingReviewButton;
